export default {
  header: {
    size: '0.875rem',
    border: {
      style: 'solid',
      thickness: '0.0625rem',
    },
    cell: {
      padding: {
        top: '0',
        bottom: '0.625rem',
        left: '0',
        right: '0.4375rem',
      },
      first: {
        width: '48%',
      },
    },
  },
  cell: {
    size: '0.875rem',
    padding: {
      top: '0.5rem',
      right: '2.5rem',
      bottom: '0',
      left: '0',
    },
    textAlign: 'left',
  },
};
